import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-turquoise-50 via-cyan-50 to-turquoise-100">
      <div className="flex flex-col items-center justify-center">
        <img
          src="/logo.png"
          alt="Fluxara Logo"
          className="w-64 h-64 object-contain animate-pulse-opacity"
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
